'use client';
import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  color: ${({ theme }) => theme.palette.brownishGrey};
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px 15px 13px 15px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  border: 1px solid ${({ theme }) => theme.palette.inputBorderColor};
  border-radius: 4px;
  transition: border-color 0.3s ease;

  :focus-within {
    border: 1px solid ${({ theme }) => theme.palette.inputBorderColorActive};
  }
`;

export const InputHelperLabel = styled.span`
  font-size: 18px;
  font-weight: 600;
  min-width: 45px;
  color: ${({ theme }) => theme.palette.black11};
`;

export const FormItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InputLabel = styled.label`
  font-weight: bold;
`;

export const InputLeftIconWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.inputBorderColorActive};
  display: flex;
  padding: 4px;
  border-radius: 50%;
`;
